import { isIOSNative } from '@xunlei/universal-native-api'

export const isHezi = navigator.userAgent.includes('Hezi')
export const isAndroidHezi = isHezi && (typeof window.HeZi === 'object' && window.HeZi)
export const isIOSHezi = isHezi && isIOSNative
export const isHeziNative = isAndroidHezi || isIOSHezi
